import Header from './Headers';
import Const from '../util/Constants';
import Config from '../config/config';

class ConditionalFieldAPI {

  static list = (success, failure) => {
    fetch(`${Config.app.link}api/conditional-field/list`, new Header('GET'))
    .then(res => Const.ProcessAPI(res, success, failure))
    .catch(er => failure(er));
  }

  static get = (role, field_id, success, failure) => {
    fetch(`${Config.app.link}api/conditional-field/get`, new Header('POST',  { role, field_id }))
    .then(res => Const.ProcessAPI(res, success, failure))
    .catch(er => failure(er));
  }

  static save = (body, success, failure) => {
    fetch(Config.app.link + 'api/conditional-field/add-edit', new Header('POST', body))
    .then(res => Const.ProcessAPI(res, success, failure))
    .catch(er => failure(er));
  }
}
export default ConditionalFieldAPI;